<template>
  <LayoutOneColumn>
    <PageEditor
      class="h-full"
      :page-link="pageLink"
      :is-admin="authStore.isAdmin"
    />
  </LayoutOneColumn>
</template>

<script setup lang="ts">
import { useAuth } from '~/stores/auth'

const route = useRoute()
const localeRoute = useLocaleRoute()
const host = useHost()
const authStore = useAuth()

const pageLink = computed(() => {
  return `${host}${localeRoute(route)?.path}`
})
</script>
